/* import __COLOCATED_TEMPLATE__ from './seat-list.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();